"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _pluralize = _interopRequireDefault(require("pluralize"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../Components/Button"));
var _Flex = _interopRequireDefault(require("../../Components/Flex"));
var _Row = _interopRequireDefault(require("../../Components/Row"));
var _RowList = _interopRequireDefault(require("../../Components/RowList"));
var _String = _interopRequireDefault(require("../../Components/String"));
var _Ul = _interopRequireDefault(require("../../Components/Ul"));
var _Redeem = _interopRequireDefault(require("@mui/icons-material/Redeem"));
var _GiftCardsRedeemTicketsSessionSelectorModule = _interopRequireDefault(require("./GiftCardsRedeemTicketsSessionSelector.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GiftCardsRedeemTicketsSessionSelector = props => {
  const {
    giftCardData,
    itemsBeingAddedToBasket,
    onAddToBasket,
    showDescription
  } = props;

  /**
   * Session selected
   * We add it at full price, the server basket determines if the Gift Card applies
   */
  const handleSessionSelect = async validSession => {
    const session = validSession.Session;
    const ticketType = validSession.TicketType;
    const fare = validSession.Fare;
    const basketItem = _hopsSdkJs.CheckoutBasketItem.construct({
      OrderableType: _hopsSdkJs.OrderableTypes.TicketSession,
      Item: {
        Session: {
          ...session,
          Trains: session.Trains?.map(Id => ({
            Id
          }))
        },
        FareId: fare.Id,
        FareType: fare.Type,
        TicketType: ticketType
      },
      Price: 0,
      // fare.Price,
      Quantity: 1,
      VatProportion: 0,
      // fare.VatProportion,
      VatRate: 0 // fare.VatRate
    });
    await onAddToBasket(session.Id, basketItem);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RowList.default, {
    gap: 2,
    children: giftCardData.Inventory?.Validity.Sessions?.map((validSession, key) => {
      const session = validSession.Session;
      const startDate = _hopsSdkJs.Localisation.formatDateTime(session.StartDate, _hopsSdkJs.Localisation.DateTimeFormats.LongDate);
      const startWeekday = `${_hopsSdkJs.Localisation.formatDateTime(session.StartDate, _hopsSdkJs.Localisation.DateTimeFormats.LongWeekday)}, `;
      const startTime = session.StartTime ? _hopsSdkJs.Localisation.formatDateTime(`${session.StartDate} ${session.StartTime}`, _hopsSdkJs.Localisation.DateTimeFormats.ShortTime) : "";
      const endDate = session.EndDate ? _hopsSdkJs.Localisation.formatDateTime(session.EndDate, _hopsSdkJs.Localisation.DateTimeFormats.LongDate) : "";
      const endWeekday = session.EndDate ? `${_hopsSdkJs.Localisation.formatDateTime(session.EndDate, _hopsSdkJs.Localisation.DateTimeFormats.LongWeekday)}, ` : "";
      const endTime = session.EndTime ? _hopsSdkJs.Localisation.formatDateTime(`${session.EndDate ?? session.StartDate} ${session.EndTime}`, _hopsSdkJs.Localisation.DateTimeFormats.ShortTime) : "";
      const ticketType = validSession?.TicketType;
      const availability = ticketType?.Availability;
      const selectedCapacity = ticketType?.People;
      const lbl = `1x ${ticketType?.Name}`;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Row.default, {
        className: _GiftCardsRedeemTicketsSessionSelectorModule.default.rowRoot,
        classNameInner: `${_GiftCardsRedeemTicketsSessionSelectorModule.default.row}`.trim(),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
          className: _GiftCardsRedeemTicketsSessionSelectorModule.default.sessionDetails,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
            gap: 0,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
              gap: 0,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
                bold: true,
                classNameFlex: _GiftCardsRedeemTicketsSessionSelectorModule.default.date,
                color: "primary",
                fontSize: "inherit",
                str: session?.Product.Name
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
                classNameFlex: _GiftCardsRedeemTicketsSessionSelectorModule.default.date,
                color: "secondary",
                fontSize: "inherit",
                str: `${startWeekday} ${startDate} ${startTime} ${(endDate || endTime) && " - "} ${endWeekday} ${endDate} ${endTime}`
              })]
            })
          }), showDescription && /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
            gap: 0.5,
            lineHeight: 1.8,
            str: session.Description
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
              bold: true,
              noFlex: true,
              str: "Fare"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Ul.default, {
              className: _GiftCardsRedeemTicketsSessionSelectorModule.default.fareDetails,
              gap: 0.5,
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                children: [lbl, " ", selectedCapacity >= 1 && `(${selectedCapacity} ${(0, _pluralize.default)("person", selectedCapacity)} total)`, /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  className: _GiftCardsRedeemTicketsSessionSelectorModule.default.sessionAvailability,
                  children: ["[", `${availability !== 0 ? `${availability ? `${availability} available` : `Unlimited availability`}` : `Sold Out`}`, "]"]
                })]
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
            alignItems: "center",
            columnar: true,
            wrap: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
              className: _GiftCardsRedeemTicketsSessionSelectorModule.default.addToBasket,
              color: "secondary",
              disabled: availability === 0,
              label: `Redeem ${validSession.TicketType?.Name}`,
              loading: itemsBeingAddedToBasket?.includes(session.Id),
              onClick: handleSessionSelect,
              startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Redeem.default, {}),
              value: validSession,
              variant: "contained"
            })
          })]
        })
      }, key);
    })
  });
};
GiftCardsRedeemTicketsSessionSelector.propTypes = {
  showDescription: _propTypes.default.bool
};
GiftCardsRedeemTicketsSessionSelector.defaultProps = {
  showDescription: true
};
var _default = exports.default = GiftCardsRedeemTicketsSessionSelector;